var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"innerView",staticStyle:{"margin-top":"5px","border":"1px solid #ddd"},style:({height:_vm.height})},[_c('mw-view',{ref:"view",attrs:{"id":_vm.viewId,"tableParams":_vm.tableParams,"params":_vm.formConfig,"formValue":_vm.formValue}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-771292b5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/common/components/extend/form/src/components/imbeddedView.vue
// module id = 1042
// module chunks = 0 1